import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import HomeContainer from "@components/views/Home/HomeContainer";

function Home() {
  return <HomeContainer />;
}

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      headerBehaviors: {
        tourGuideAllowed: true,
      },
      ...(await getMessagesForNamespaces(locale, [
        "closets",
        "common",
        "product",
        "accounts",
        "address_form",
      ])),
    },
  };
}

Home.requireAuth = process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER !== "true";

export default Home;
